import { PagerComposition } from '@codeleap/web'
import { StyleRegistry } from '../styles'
import { createStyles } from '@codeleap/styles'

const createPagerVariant = createStyles<PagerComposition>

const DOT_SIZE = 8

export const PagerStyles = {
  default: createPagerVariant((theme) => ({
    wrapper: {
      ...theme.presets.fullWidth,
      ...theme.presets.column,
    },
    footerWrapper: {
      ...theme.presets.column,
    },
    dots: {
      ...theme.presets.fullWidth,
      ...theme.presets.row,
      gap: theme.spacing.value(1),
      ...theme.presets.justifyCenter,
    },
    dot: {
      height: DOT_SIZE,
      width: DOT_SIZE,
      cursor: 'pointer',
      borderRadius: theme.radius.infinite,
      backgroundColor: theme.baseColors.neutralSolid300,
    },
    'dot:selected': {
      height: DOT_SIZE,
      width: DOT_SIZE,
      backgroundColor: theme.baseColors.primarySolid300,
      cursor: 'pointer',
      borderRadius: theme.radius.infinite,
    },
    'dot:disabled': {
      cursor: 'auto',
    },
  })),
}

StyleRegistry.registerVariants('Pager', PagerStyles)
